import React, { useState, useEffect, useCallback } from "react";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin,
  Switch,
} from "antd";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  PlusCircleOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import {
  apiConfig,
  GetLabelForReportParameter,
  labelConfig,
  staticConfig,
} from "../reports.config";
import styles from "../../../assets/styles/styles";
import dayjs from "dayjs";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;
const { TextArea } = Input;

const EditCustomReport = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();

  const [form] = Form.useForm();
  const reportType = Form.useWatch("reportType", form);
  const [template, setTemplate] = useState([]);
  const [paramterList, setParameterList] = useState([]);
  const [isAddressEnabled, setIsAddressEnabled] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [templateLoading, setTemplateLoading] = useState(false);
  const [reportLoading, setReportLoading] = useState(false);
  const [report, setReport] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    customerInfo: null,
    customerAddressInfo: null,
  });
  const isCoreReport = report.coreReport;

  // ------------------------------------------------------------------------------------------------------
  // In a case where a parameter is deleted and the same parameter is added without updating the report,
  // an error would be thrown because the id for the new parameter would be null as it has
  // been deleted but that same parameter still exists in the database with its Id
  // So, this variable stores the originally deleted parameter and replaces the new one in cases like this.
  const [deletedParameters, setDeletedParameters] = useState([]);
  // ------------------------------------------------------------------------------------------------------

  useEffect(() => {
    getTemplate();
    getReport();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.Reports}/template`;
    let body = {
      session,
    };

    setTemplateLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setTemplateLoading(false);
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        setIsAddressEnabled(objList.isAddressEnabled);

        let allowedParameters = [];
        let allowedReportSubTypes = [];
        let allowedReportTypes = [];
        let reportCategories = [];

        objList?.allowedParameters?.forEach((element) => {
          allowedParameters.push({
            value: element.id,
            label: GetLabelForReportParameter(element.parameterName),
          });
        });

        objList?.allowedReportSubTypes?.forEach((element) => {
          allowedReportSubTypes.push({
            value: element,
            label: element,
          });
        });
        objList?.allowedReportTypes?.forEach((element) => {
          allowedReportTypes.push({
            value: element,
            label: element,
          });
        });
        objList?.reportCategories?.forEach((element) => {
          reportCategories.push({
            value: element?.id,
            label: element?.parameterName,
          });
        });
        setTemplate({
          allowedParameters,
          allowedReportSubTypes,
          allowedReportTypes,
          reportCategories,
        });

        setTemplateLoading(false);
      }
    });
  }
  function getReport() {
    const url = `${apiConfig.Reports}/${state?.key}`;
    let body = {
      session,
    };

    setReportLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setReportLoading(false);
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setReportLoading(false);
        const objList = res;
        console.log(objList, "objList");
        setReport(objList);
        form.setFieldsValue({
          ...objList,
          reportCategory: objList?.reportCategory?.id,
        });
        setParameterList(
          objList?.reportParameters.map((item) => ({
            id: item.id,
            parameterId: item.parameterId,
            parameterName: item.parameterName,
            description: template?.allowedParameters?.find(
              (param, i) => param?.value === item?.id
            )?.label,
          })) ?? []
        );
      }
    });
  }

  console.log(paramterList, template);
  const onSubmit = (formValues) => {
    console.log(formValues);

    // return;
    formValues.reportParameters = paramterList?.map((item) => {
      const exists = deletedParameters.find(
        (param) => Number(param.parameterId) === Number(item.parameterId)
      );
      if (exists) {
        return {
          id: exists.id,
          parameterId: exists.parameterId,
          parameterName: item.reportParameterName,
        };
      }
      return {
        id: item.id || "",
        parameterId: item.parameterId,
        parameterName: item.reportParameterName,
      };
    });
    if (isCoreReport) {
      delete formValues.coreReport;
      delete formValues.reportCategory;
      delete formValues.reportName;
      delete formValues.reportParameters;
      delete formValues.reportSql;
      delete formValues.reportType;
      delete formValues.description;
    }
    const body = {
      ...formValues,
      // dateFormat: "dd MMMM yyyy",
      // locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      `${apiConfig.Reports}/${state?.id}`,
      (err, res) => {
        if (err) {
          console.log(err, "err");
          setIsLoading(false);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          setIsLoading(false);

          // navigate("/detail-customer", {
          //   sta: { id: res.clientId, branchId: res.officeId },
          // });
          navigate("/custom-report-builder");
          BOM.AlertMsg(cnt.SUCCESS, "Report updated successfully");
          //STOP LOAD
        }
      }
    );
  };

  function handleDeleteParameter(item) {
    const exists = deletedParameters.find(
      (items) => Number(items.parameterId) === Number(item.parameterId)
    );
    if (!exists) {
      setDeletedParameters([...deletedParameters, item]);
    }
    const updatedList = paramterList.filter(
      (param) => param.parameterId !== item.parameterId
    );
    setParameterList(updatedList);
    BOM.AlertMsg(cnt.SUCCESS, "Parameter removed successfully");
  }
  function onCancel() {
    navigate("/custom-report-builder");
  }

  console.log(deletedParameters, "deletedParameters");
  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.updateReport}
        pageItems={staticConfig.editCustomReportsBreadcrumbItems}
      />
      <Spin
        spinning={isLoading || reportLoading || templateLoading}
        size="large"
      >
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Row>
            <Form
              initialValues={{
                active: false,
                isStaff: false,
                openCasa: false,
              }}
              form={form}
              layout="vertical"
              onFinish={onSubmit}
              name="customer-info"
              style={{ width: "100%" }}
            >
              <Row>
                <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.updateReport}
                </Title>
              </Row>
              <Divider style={{ marginTop: 10, marginBottom: 30 }} />
              <Row>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.reportDetails}
                  </Title>
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.reportName}
                    name="reportName"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.reportName),
                      },
                    ]}
                  >
                    <Input
                      className="of-bold-disable-input"
                      disabled={isCoreReport}
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.reportName
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.reportCategory}
                    name="reportCategory"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.reportCategory),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.reportType}`,
                        "select"
                      )}
                      options={template?.reportCategories}
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.reportType}
                    name="reportType"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.reportType),
                      },
                    ]}
                  >
                    <Select
                      className="read-only-select"
                      disabled={isCoreReport}
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.reportType}`,
                        "select"
                      )}
                      options={template?.allowedReportTypes}
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={16} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.description}
                    name="description"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: BOM.CheckReqFld(labelConfig.description),
                    //   },
                    // ]}
                  >
                    <TextArea
                      className="of-bold-disable-input"
                      style={{ minHeight: 100 }}
                      disabled={isCoreReport}
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.description
                      )}
                    />
                  </Form.Item>
                </Col>
                {reportType &&
                  reportType?.toLowerCase() !== "table" &&
                  reportType?.toLowerCase() !== "pentaho" && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.reportSubType}
                        name="reportSubType"
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(labelConfig.reportSubType),
                          },
                        ]}
                      >
                        <Select
                          className="read-only-select"
                          disabled={isCoreReport}
                          placeholder={BOM.handlePlaceholderMsg(
                            `${labelConfig.reportSubType}`,
                            "select"
                          )}
                          options={template?.allowedReportSubTypes}
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  )}

                <Col
                  span={8}
                  style={{
                    padding: "0px 8px",
                    marginTop: 30,
                    display: "flex",
                    gap: 10,
                  }}
                >
                  <Form.Item
                    name={"useReport"}
                    style={{ margin: 0, padding: 0 }}
                    valuePropName="checked"
                  >
                    <Switch className="custom-switch-2" />
                  </Form.Item>
                  <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>
                    User Report UI
                  </Text>
                </Col>
              </Row>

              {reportType && reportType?.toLowerCase() !== "pentaho" && (
                <>
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                      {labelConfig.SQL}
                    </Title>
                  </Divider>
                  <Row>
                    <Col span={24} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.SQL}
                        name="reportSql"
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(labelConfig.SQL),
                          },
                        ]}
                      >
                        <TextArea
                          className="of-bold-disable-input"
                          style={{ minHeight: 100 }}
                          disabled={isCoreReport}
                          placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.SQL
                          )}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}

              <Row>
                <div
                  style={{
                    width: "100%",
                    padding: "16px",
                  }}
                >
                  {/* <Spin spinning={isLoading} tip="Loading..." size="large"> */}
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                      {labelConfig.reportParameters}
                    </Title>
                  </Divider>

                  {BOM.HasPermission("READ_ADDRESS") && (
                    <AddParameterModal
                      formData={formData}
                      isModalOpen={isModalOpen}
                      setIsModalOpen={setIsModalOpen}
                      paramterList={paramterList}
                      setParameterList={setParameterList}
                      template={template}
                      isCoreReport={isCoreReport}
                    />
                  )}
                  {paramterList?.length > 0 && (
                    <List
                      // itemLayout="horizontal"
                      dataSource={paramterList}
                      grid={{ gutter: 16, column: 2 }}
                      renderItem={(item, index) => (
                        <List.Item
                          style={{
                            display: "flex",
                            margin: 0,
                            border: "1px solid #d9d9d9",
                            borderRadius: 10,
                            padding: 20,
                            marginBottom: 20,
                          }}
                          actions={[]}
                        >
                          {/* <Card> */}
                          <List.Item.Meta
                            description={`${
                              item?.reportParameterName ?? "----"
                            } `}
                            title={
                              template?.allowedParameters?.find(
                                (param, i) =>
                                  String(param?.value) ===
                                  String(item?.parameterId)
                              )?.label
                            }
                          />
                          <Button
                            type="primary"
                            disabled={isCoreReport}
                            danger
                            shape="round"
                            size="small"
                            onClick={() => handleDeleteParameter(item)}
                            icon={<DeleteOutlined />}
                            style={{
                              boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                              // marginLeft: "auto",
                            }}
                          >
                            Remove
                          </Button>
                          {/* </Card> */}
                        </List.Item>
                        // <Card style={{ border: "1px solid red" }}></Card>
                      )}
                    />
                  )}
                  {/* </Spin> */}
                </div>
              </Row>

              <Row>
                <Divider />
                {BOM.HasPermission("CREATE_CLIENT") && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    htmlType="submit"
                    backgroundColor="#92428B"
                    colorText="white"
                    hoverBackground="#AD4EA7"
                    isLoading={isLoading}
                  />
                )}
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form>
          </Row>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(EditCustomReport);

const AddParameterModal = (props) => {
  const {
    template,
    isModalOpen,
    setIsModalOpen,
    paramterList,
    setParameterList,
    isCoreReport,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSaveParameter = (formValues) => {
    const newParameter = {
      id: "",
      reportParameterName: formValues.reportParameterName,
      parameterId: String(formValues.parameterId),
    };
    setParameterList([...paramterList, newParameter]);
    BOM.AlertMsg(cnt.SUCCESS, "Parameter added successfully");
    setIsModalOpen(false);
    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        disabled={isCoreReport}
        onClick={showModal}
        icon={<PlusCircleOutlined />}
        shape="round"
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
          color: "white",
        }}
      >
        {labelConfig.add}
      </Button>

      <Modal
        title="Parameter Setup"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={1000}
      >
        <Form
          form={useForm}
          layout="vertical"
          onFinish={handleSaveParameter}
          name="address-info"
        >
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.parameter}
                name={"parameterId"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.parameter),
                  },
                ]}
              >
                <Select
                  className="read-only-select"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.parameter,
                    "select"
                  )}
                  options={template?.allowedParameters}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={`${labelConfig.parameterName} (Passed to Pentaho)`}
                name={"reportParameterName"}
                // rules={[
                //   {
                //     required: true,
                //     message: BOM.CheckReqFld(labelConfig.parameterName),
                //   },
                // ]}
              >
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.parameterName
                  )}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Divider />
            <CustomButton
              content="Save"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              htmlType="submit"
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />

            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </Row>
  );
};

// [
//   {
//       "id": 259,
//       "parameterId": 1,
//       "reportParameterName": "startDateSelect"
//   },
//   {
//       "id": 256,
//       "parameterId": 2,
//       "reportParameterName": "endDateSelect"
//   },
//   {
//       "id": 258,
//       "parameterId": 5,
//       "reportParameterName": "OfficeIdSelectOne"
//   },
//   {
//       "id": 257,
//       "parameterId": 6,
//       "reportParameterName": "loanOfficerIdSelectAll"
//   },
//   {
//       "id": 601,
//       "parameterId": 20,
//       "reportParameterName": "fundIdSelectAll"
//   },
//   {
//       "id": 602,
//       "parameterId": 1006,
//       "reportParameterName": "transactionId"
//   },
//   {
//       "id": "",
//       "parameterId": "1009",
//       "reportParameterName": "As on"
//   }
// ]

// [
//   {
//       "id": 259,
//       "parameterId": 1,
//       "reportParameterName": "startDateSelect"
//   },
//   {
//       "id": 256,
//       "parameterId": 2,
//       "reportParameterName": "endDateSelect"
//   },
//   {
//       "id": 258,
//       "parameterId": 5,
//       "reportParameterName": "OfficeIdSelectOne"
//   },
//   {
//       "id": 257,
//       "parameterId": 6,
//       "reportParameterName": "loanOfficerIdSelectAll"
//   },
//   {
//       "id": 601,
//       "parameterId": 20,
//       "reportParameterName": "fundIdSelectAll"
//   },
//   {
//       "id": 602,
//       "parameterId": 1006,
//       "reportParameterName": "transactionId"
//   },
//   {
//       "id": "",
//       "parameterId": "1009",
//       "reportParameterName": "As on"
//   }
// ]
